class Circle {
  /**
   *
   * @param {YCLatLng} center
   * @param {number} radius
   */
  constructor(center, radius) {
    this.center = center;
    this.radius = radius;
  }
}

export default Circle;
